import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { listPatients } from '../../actions/patientActions';

const Search = ({ handleItemClick, query, setQuery }) => {
  const [filteredResults, setFilteredResults] = useState([]);
  const [showList, setShowList] = useState(false);
  const [debouncedQuery, setDebouncedQuery] = useState(query);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const patientList = useSelector((state) => state.patientList);
  const { patients } = patientList;

  // Ensure patient list loads on mount
  useEffect(() => {
    if (userInfo) {
      dispatch(listPatients({}));
    } else {
      navigate("/signin");
    }
  }, [dispatch, userInfo]);

  // Debounce logic: wait 5 seconds after typing stops
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 3000); // 5000ms delay (5 seconds)

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  // Trigger API search once debounce finishes
  useEffect(() => {
    if (debouncedQuery.trim()) {
      dispatch(listPatients({ firstName: debouncedQuery }));
    }
    setShowList(debouncedQuery.trim().length > 0);
  }, [debouncedQuery, dispatch]);

  useEffect(() => {
    setFilteredResults(patients);
  }, [patients]);

  const handleInputChange = (e) => {
    const input = e.target.value;
    setQuery(input); // this updates query, which triggers debounce
  };

  return (
    <div className="mb-3">
      <input
        type="text"
        placeholder=" Search..."
        value={query}
        onChange={handleInputChange}
        style={{
          width: '70%',
          padding: '3px',
          marginLeft: '10px',
          fontSize: '16px',
          borderRadius: '10px'
        }}
        onClick={() => setShowList(filteredResults.patient?.length > 0)}
      />
      {showList && (
        <ul
          style={{
            position: 'fixed',
            top: "150px",
            listStyleType: 'none',
            padding: '0',
            margin: '0',
            border: '1px solid #ddd',
            borderRadius: '4px',
            maxHeight: '150px',
            overflowY: 'auto',
            backgroundColor: '#fff',
            zIndex: 1000
          }}
        
          onMouseLeave={(e) =>  setShowList(false)}
        >
          {filteredResults && filteredResults.patient?.length > 0 ? (
            filteredResults.patient.map((item) => (
              <li
                key={item._id}
                onClick={() => handleItemClick(item)}
                style={{
                  padding: '10px',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s',
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = '#f0f0f0')}
                onMouseLeave={(e) =>  e.target.style.backgroundColor = '#fff'}
              >
                {item.firstName}{" "}{item.lastName}-{item.patientNumber}
              </li>
            ))
          ) : (
            <li style={{ padding: '10px', color: '#999' }}>
              No matching results
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default Search;